// Frontend contract for the 4-slot sprint abstraction. The backend maps these
// to concrete per-track sprints; everything except TrackSprintDetail speaks in
// these slots. See docs/sprint-slots-plan.md.

// Slots a user may assign directly. `backlog` is derived server-side (a task
// ages into it when its sprint ends with an incomplete goal), so it is shown
// but never sent as a write target.
export const WRITABLE_SLOTS = ["current", "next", "bucket"];

export const SLOT_LABELS = {
  backlog: "Backlog",
  current: "Current",
  next: "Next",
  bucket: "Bucket",
};

// "5 Jul" — single date (dropdown, current/next only).
export const fmtDay = (d) =>
  d
    ? new Date(d).toLocaleDateString("en-GB", { day: "numeric", month: "short" })
    : "";

// "6 Jul - 17 Jul" — range (TrackSprintDetail).
export const fmtRange = (s, e) =>
  s && e ? `${fmtDay(s)} - ${fmtDay(e)}` : "";

// Build the dropdown options for a task, showing the sprint start date for
// current/next only (bucket/backlog are floating/unscheduled — no fixed date).
// `sprintWindow` is the task's `sprint_window` payload from the API.
export function slotOptions(sprintWindow = {}) {
  const dateFor = (slot) => {
    const start = sprintWindow?.[slot]?.start;
    return start ? ` (${fmtDay(start)})` : "";
  };
  return WRITABLE_SLOTS.map((slot) => ({
    value: slot,
    label: `${SLOT_LABELS[slot]}${dateFor(slot)}`,
  }));
}

// Label for a task's current slot, including the derived `backlog` state.
export function slotLabel(slot, sprintWindow = {}) {
  if (!slot) return SLOT_LABELS.backlog;
  const start = sprintWindow?.[slot]?.start;
  const base = SLOT_LABELS[slot] || slot;
  return start ? `${base} (${fmtDay(start)})` : base;
}
